
    import { Component, Vue } from 'vue-property-decorator'
    const dq_1 = require('./../../../assets/imgs/dq_1_new.png'),
        dq_2 = require('./../../../assets/imgs/dq_2_new.png'),
        dq_3 = require('./../../../assets/imgs/dq_3_new.png');
    @Component({
        name: 'DashQuestion'
    })
    export default class DashQuestion extends Vue {
        private questionList: Array<any> = [
            { icon: dq_1, question: 'Q:什么时候可以报名？怎么报名？', answer: '测试结束之后就可以凭测试成绩通过手机微信小程序自助报名缴费。' },
            { icon: dq_2, question: 'Q:好问开设了哪些科目？是否会开设其他科目？', answer: '好问目前只开设了理科以及语文、英语科目，好问做事的原则是专注，对于开设新的科目是非常慎重的，为了保证良好的教学质量和教学服务，一定是准备充足了才开设新的学科。' },
            { icon: dq_3, question: 'Q:报名之后还能不能升班?', answer: '可以，好问的分层教学，是为了将学习层次比较接近的孩子放在同一个班级，这样一方面有利于老师上课时对进度的控制，更重要的是让孩子在合适的班级学习，既能够跟随上课的进度。' },
            { icon: dq_3, question: 'Q:家长可以旁听吗？', answer: '可以，家长在遵守上课规则的前提下可以跟学生一起在课堂上进行学习。' },
            { icon: dq_1, question: 'Q:报名后不满意怎么办？', answer: '好问支持自由调课转班，家长可以自行在小程序或官网上进行调课转班，转到自己心仪的班级。也可以到前台，让前台帮忙操作。' },
            { icon: dq_2, question: 'Q:报名之后能退费吗?', answer: '每学期课程剩余课次不少于三次，均可随时退费，不退单次课。' }
        ]
    }
